import { OfferT } from "../../../domain";
import React from "react";
import { Table } from "../../../../../shared/infrastructure";
import { useInfiniteGetOffers } from "../../services";
import { useRepViewTableColumns } from "../hooks";

type OfferCardRepViewTableProps = {
  offer: OfferT;
  isOpen: boolean;
};

export const OfferCardRepViewTable = ({
  offer,
  isOpen,
}: OfferCardRepViewTableProps): React.ReactElement => {
  const { logsTableColumns, sortByValues, filters } = useRepViewTableColumns({
    order_number: offer.order_number,
    movement_number: offer.movement_number,
  });

  const {
    allPages,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useInfiniteGetOffers(
    "all",
    {
      ...sortByValues,
      ...filters,
    },
    { enabled: isOpen }
  );

  return (
    <section className="p-[16px]">
      {isOpen ? (
        <Table
          columns={logsTableColumns}
          message="No offers available"
          data={allPages ?? []}
          isLoading={isLoading || isFetchingNextPage}
          getNextPage={fetchNextPage}
          hasMorePages={!!hasNextPage}
          maxHeight={250}
          rowStyles={{
            borderBottom: 1,
            borderBottomStyle: "solid",
            borderBottomColor: "#F0F0F0",
          }}
        />
      ) : null}
    </section>
  );
};
